// extracted by mini-css-extract-plugin
module.exports = {"bb-hero-emergency-overlay":"bb-hero-emergency-overlay__Vh3X1"};